<ng-template id="emailSubscription" #emailSubscription bsModal class="modal fade show" tabindex="-1" role="dialog" aria-labelledby="EmailSubscription" aria-hidden="true">
    <form [formGroup]="EmailDigest" (ngSubmit)="saveSubscription(EmailDigest.value)" novalidate>
        <div class="modal-header bg-info text-white">
            <p class="modal-title">
                <strong class="mr-1">Opt-in for Email Digest</strong>
            </p>
            <button type="button" class="btn btn-sm btn-info" aria-label="Close" (click)="closePopup(true)">
                <span aria-hidden="true"><i class="fa fa-close"></i></span>
            </button>
        </div>
        <div class="modal-body">
            <div class="md-3" style="margin: -10px 0px 5px 0px;">
                <label class="form-label" style="font-weight: 900;">Please confirm your email address</label><br>
                <div class="col-md-8" [ngClass]="{ 'has-error': !EmailDigest.controls['email'].valid && EmailDigest.controls['email'].touched }">
                    @if (!isPrivatePortal) {
                    <input type="email" class="form-control" id="email" style="font-weight: 400;" formControlName="email" (focusout)="getSubscriptionDetailsByEmail();" />
                    }
                    @if (isPrivatePortal) {
                    <input type="email" class="form-control" id="email" style="font-weight: 400;" [disabled]="true" formControlName="email" />
                    }
                    @if (EmailDigest.controls['email'].hasError('required') && submitted) {
                    <div class="col-md-12 alert alert-danger">
                        Email is required.
                    </div>
                    }
                    @if (EmailDigest.controls['email'].hasError('pattern')) {
                    <div class="col-md-12 alert alert-danger">
                        Please enter a valid email address.
                    </div>
                    }
                </div>
            </div>
            <div class="md-3">
                <label class="form-label" style="font-weight: 900;">Would you like to be notified via email if the content of this portal has been updated?</label><br>
                <div class="col-md-8">
                    <div [ngClass]="{ 'has-error': !EmailDigest.controls['notify'].valid && EmailDigest.controls['notify'].touched }">
                        <input type="radio" id="yes" formControlName="notify" [value]="EmailYes" (change)="divShowHide(true);"><label style="font-weight: 400;">Yes</label>
                        <br>
                        <input type="radio" id="No" formControlName="notify" [value]="EmailNo" (change)="divShowHide(false);"> <label style="font-weight: 400;">No</label>
                    </div>
                    @if (EmailDigest.controls['notify'].errors?.['required'] && submitted) {
                    <div class="alert alert-danger">
                        Notification selection is required.
                    </div>
                    }
                </div>

            </div>
            @if (IsDivVisible) {
            <div class="md-3" style="margin-top: -5px;">
                <label class="form-label" style="font-weight: 900;">Please select the frequency of the email digest you wish to receive</label><br>
                <div class="col-md-8">
                    <div [ngClass]="{ 'has-error': !EmailDigest.controls['frequency'].valid && EmailDigest.controls['frequency'].touched }">
                        <input type="radio" id="immediate" formControlName="frequency" [value]="Immediate">
                        <label for="immediate" style="font-weight: 400;">Daily Digest</label>
                        <br>
                        <input type="radio" id="weekly" formControlName="frequency" [value]="Weekly">
                        <label for="weekly" style="font-weight: 400;">Weekly Digest</label>
                        <br>
                        <input type="radio" id="monthly" formControlName="frequency" [value]="Monthly">
                        <label for="weekly" style="font-weight: 400;">Monthly Digest</label>
                    </div>
                    @if (EmailDigest.controls['frequency'].errors?.['required'] && submitted) {
                    <div class="alert alert-danger">
                        Please select a frequency.
                    </div>
                    }
                </div>
            </div>
            }

            <div class="md-3">
                <div class="row" style="margin-left: -5px; display: flex; align-items: flex-end;">
                    @if (IsDivVisible) {
                    <label class="form-label" style="font-weight: 900;">Select the location(s) you would like to be notified for</label>
                    }<br>
                    @if (IsDivVisible) {
                    <div class="col-md-8" style="margin-bottom: 10px;">
                        <input type="text" class="form-control" placeholder="search location" (input)="filterGeography($any($event.target).value)" />
                    </div>
                    }
                    @if (IsDivVisible) {
                    <div class="col-md-8">
                        <div class="row" style="margin-left: -15px; overflow-y: auto; max-height: 135px;" [formGroup]="getUserCountriesFormGroup()">
                            <div class="col-md-12" style="display: flex;align-items: center;">
                                <input type="checkbox" id="selectAll" style="margin-bottom: 10px;" value="false" [checked]="selectAll" (change)="selectAllCountries($event)">
                                <label for="selectAll" style="font-weight: 400; margin-left: 5px;">Select All</label>
                            </div>
                            @for (geo of countries; track geo) {
                            <div class="col-md-6" style="display: flex;align-items: center;">
                                <input type="checkbox" style="margin-bottom: 10px;" id="{{geo.id}}" value="{{geo.id}}" [formControlName]="geo.id" (change)="onCheckboxChange($event)">
                                <label for="{{geo.id}}" style="font-weight: 400; margin-left: 5px;">{{geo.shortName}} </label>
                            </div>
                            }
                        </div>
                        @if (selectedCountry === 0 && countries.length !== 0 && submitted) {
                        <div class="alert alert-danger">
                            Please select at least one location.
                        </div>
                        }
                    </div>
                    }
                    @if (!IsDivVisible) {
                    <div class="col-md-8">
                        <span></span>
                    </div>
                    }
                    <div class="col-md-4">
                        <button type="submit" class="btn btn-info pull-right">Confirm</button>
                        <button type="button" class="btn btn-light pull-right mr-3" (click)="closePopup(true)">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</ng-template>